jQuery(document).ready(function ($) {
  // scroll triggeres the scroll bases alignment
  $(window).scroll(alignShareIcon);
  // resize must remove sticky class when no longer in tab mode
  $(window).resize(alignShareIcon);


  /**
   * Triggers the restyling of the share buttons, on tablet bp sizes, when needed during `resize` or `scroll`
   */
  function alignShareIcon() {
    var grid = new Grid();

    var social = $('.sharing');
    if (0 !== social.length) {
      // only execute when there is some sharing at all on the page
      var list_group = $('.list-group', social);

      if (grid.isBp(['sm', 'md', 'lg', 'xl'])) {

        if ($(window).scrollTop() + 148 > social.offset().top) {
          // when user scrolled past the sharing buttons
          if (!social.hasClass('sticky')) {
            // but sticky is not already initialised

            // as sticky changes the height, but height must be set after `sticky` change
            var social_init_height = social.height();

            social.addClass('sticky');
            social.css({
              height: social_init_height
            });
          }

          // need to be done all the time
          /*
          was needed when mobile have sticky too, saved here as scribble when design changes again in future
          if (grid.isBp(['xs'])) {
            var btn_trigger = $('> button', social);
            list_group.css({
              left: btn_trigger.offset().left + ((btn_trigger.width() - $('a', list_group).width()) / 2)
            });
          }
          */
        } else {
          // when user scrolled back over the sharing buttons
          social.removeClass('sticky');
          social.removeAttr('style');
          list_group.removeAttr('style');
        }
      } else {
        // when user scrolled back over the sharing buttons
        social.removeClass('sticky');
        social.removeAttr('style');
        list_group.removeAttr('style');
      }
    }
  }
});
